import {
  Directive,
  ElementRef,
  EventEmitter,
  Output,
  OnDestroy,
  Input,
  OnInit,
} from '@angular/core';

@Directive({
  selector: '[appInView]',
})
export class InViewDirective implements OnDestroy, OnInit {
  @Input('appInView') isLast!: boolean;
  @Input() index!: number;  // Add input for index
  @Output() inView = new EventEmitter<{ isLast: boolean, index: number }>();

  private observer!: IntersectionObserver;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.inView.emit({
              isLast: this.isLast,
              index: this.index
            });
          }
        });
      },
      {
        root: document.querySelector('#scroll-container'),
        threshold: 0.5
      }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
